module.exports = __webpack_public_path__ + "static/media/question.99d65cf7.svg";